interface VimeoEmbedProps {
  videoId: string
  hash?: string
  autoplay?: boolean
  muted?: boolean
  loop?: boolean
  className?: string
}

export default function VimeoEmbed({ videoId, hash, autoplay, muted, loop, className }: VimeoEmbedProps) {
  let src = `https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&title=0&byline=0&portrait=0`

  if (hash) {
    src += `&h=${hash}`
  }

  if (autoplay) {
    src += '&autoplay=1'
  }

  if (muted) {
    src += '&muted=1'
  }

  if (loop) {
    src += '&loop=1'
  }

  return (
    <div
      className={`relative w-full aspect-video rounded-card overflow-hidden bg-black [transform:translateZ(0)]${className ? ` ${className}` : ''}`}
    >
      <div className="absolute inset-x-0 -top-[8px] -bottom-[8px]">
        <iframe
          src={src}
          className="w-full h-full border-0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          title="Project video"
        />
      </div>
    </div>
  )
}
